export type ChatMessage = {
    isUser: boolean;
    text: string;
    timestamp: number;
    agentName?: string;
    kind?: "divider" | "notice";
    fromReportId?: string | null;
};

const HISTORY_PREFIX = "chatbot_history_";
const LAST_REPORT_KEY = "chatbot_last_report_id";

const keyFor = (sessionId: string) => `${HISTORY_PREFIX}${sessionId}`;

export function loadHistory(sessionId: string): ChatMessage[] {
    if (typeof window === "undefined") return [];
    try {
        const raw = window.localStorage.getItem(keyFor(sessionId));
        return raw ? (JSON.parse(raw) as ChatMessage[]) : [];
    } catch { return []; }
}

export function saveHistory(sessionId: string, msgs: ChatMessage[]) {
    try { window.localStorage.setItem(keyFor(sessionId), JSON.stringify(msgs)); } catch { }
}

export function clearHistory(sessionId: string) {
    try { window.localStorage.removeItem(keyFor(sessionId)); } catch { }
}

// Removes every stored conversation, not just the active session's. Rotating the
// session id on a report switch can leave orphaned keys behind, so a logout has to
// sweep the prefix rather than delete a single entry.
export function clearAllHistory() {
    if (typeof window === "undefined") return;
    try {
        const doomed: string[] = [];
        for (let i = 0; i < window.localStorage.length; i++) {
            const key = window.localStorage.key(i);
            if (key && key.indexOf(HISTORY_PREFIX) === 0) doomed.push(key);
        }
        doomed.forEach((key) => window.localStorage.removeItem(key));
        window.localStorage.removeItem(LAST_REPORT_KEY);
    } catch { }
}

// The report the stored conversation belongs to. Persisted so a page reload on the
// same report keeps its history, while returning to a different report clears it.
export function getLastReportId(): string | null {
    if (typeof window === "undefined") return null;
    try { return window.localStorage.getItem(LAST_REPORT_KEY); } catch { return null; }
}

export function setLastReportId(reportId: string | null) {
    if (typeof window === "undefined") return;
    try {
        if (reportId) window.localStorage.setItem(LAST_REPORT_KEY, reportId);
        else window.localStorage.removeItem(LAST_REPORT_KEY);
    } catch { }
}
